<template>
  <div class="number-input">
    <Button
      class="decrement-button"
      @click="decrement"
      type="icon"
      icon="icon icon-minus"
      size="medium"
      data-test="decrement_item_button"
    />
    <input
      class="el-input__inner number-input__field"
      :value="internalValue"
      @input="updateValue($event.target.value)"
      type="number"
      data-test="line_quantity"
    >
    <Button
      class="increment-button"
      @click="increment"
      type="icon"
      icon="icon icon-add-3"
      size="medium"
      data-test="increment_item_button"
    />
  </div>
</template>

<script>
import Button from './Button.vue';

export default {
  components: {
    Button,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: Infinity,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  methods: {
    increment() {
      this.internalValue += this.step;
      this.$emit('input', this.internalValue);
    },
    decrement() {
      this.internalValue -= this.step;
      this.$emit('input', this.internalValue);
    },
    updateValue(value) {
      const numericValue = Number(value);
      this.internalValue = numericValue;
      this.$emit('input', numericValue);
    },
  },
  watch: {
    value(value) {
      this.internalValue = value;
    },
  },
};
</script>

<style lang="scss">
.number-input__field::-webkit-inner-spin-button,
.number-input__field::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

.number-input__field[type='number'] {
  appearance: textfield;
}

.number-input {
  .number-input__field {
    padding-left: 2.2rem !important;
    padding-right: 2.2rem !important;
    text-align: center;
  }

  .increment-button {
    position: absolute;
    top: 50%;
    right: .8em;
    transform: translateY(-50%);
  }

  .decrement-button {
    position: absolute;
    top: 50%;
    left: .8rem;
    transform: translateY(-50%);
  }

  .decrement-button, .increment-button {
    &:hover {
      transform: translateY(-50%) scale(1.1);
    }

    .icon {
      font-size: 1.3rem;
    }
  }
}
</style>
